
































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { exportInfor, exportAllInfo, sqlExportInfor, sjExportInfor, healthCertExportInfor } from '@/api/index'
import { UserModule } from '@/store/modules/user'
import { queryLevel } from '@/api/order'
@Component({
  name: 'TitleIndex',
})
export default class extends Vue {
  @Prop() private flag!: any
  @Prop() private tateData!: any
  @Prop() private turnoverData!: any
  private level = 1
  private valueTime=[]

  nowIndex = 2 - 1
  value = []
  tabsParam = ['昨日', '近7日', '近30日', '本周', '本月']
  @Watch('flag')
  getNowIndex(val) {
    this.nowIndex = val
  }
  // tab切换
  toggleTabs(index: number) {
    this.nowIndex = index
    this.value = []
    this.$emit('sendTitleInd', index + 1)
  }

  created(){
    this.getLevel()
  }
  getLevel(){
    const username = UserModule.username

    queryLevel(username)
      .then((res)=>{
        if (res.data.code === 1) {
          this.level=res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }
  //  数据导出
  /** 导出按钮操作 */
  handleExport() {
    this.$confirm('是否确认导出运营数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => { // 用户点击了确定按钮
      const params = {
        beginTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[0] : undefined,
        endTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[1] : undefined,
      };

      exportInfor({ begin: params.beginTime, end: params.endTime })
        .then((response) => {
          const { data } = response;
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })); // 确保data是Blob类型，并设置正确的MIME类型
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = `数据统计.xls`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('导出失败:', error); // 处理导出失败的情况
        });
    }).catch(() => { // 用户点击了取消按钮
      // 这里可以处理取消操作，但通常不需要做什么，因为用户已经取消了导出
    });
  }

  //  sql文件导出
  /** 导出按钮操作 */
  async sqlExport() {
    // 先定义默认文件名（后续会被接口返回的文件名覆盖）
    let fileName = 'dzjkz_backup.sql';
    // 存储文件句柄（现代浏览器用）
    let fileHandle = null;
    // 标记是否已获取文件句柄
    let hasFileHandle = false;

    this.$confirm('是否确认导出SQL文件？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(async () => {
      try {
        // 关键步骤：在用户点击"确定"的同步回调中，先获取文件保存路径
        // 1. 现代浏览器：直接调用文件选择器（同步用户手势）
        if (window.showSaveFilePicker && !window.navigator.msSaveOrOpenBlob) {
          try {
            // 先用默认文件名打开选择器（后续会用接口返回的文件名覆盖）
            const options = {
              suggestedName: fileName,
              startIn: 'downloads',
              types: [{
                description: 'SQL文件',
                accept: { 'application/octet-stream': ['.sql'] },
              }],
            };
            // 这一步必须在用户点击的直接回调中，不能有异步操作前置
            fileHandle = await window.showSaveFilePicker(options);
            hasFileHandle = true;
          } catch (e) {
            console.log('用户取消了保存路径选择', e);
            return; // 用户取消则直接退出
          }
        }

        // 2. 发起接口请求获取文件数据（此时已通过安全验证）
        const response = await sqlExportInfor();
        const blob = response.data;

        // 3. 从接口响应中提取真实文件名（覆盖默认名）
        const contentDisposition = response.headers['content-disposition'] || '';
        const match = contentDisposition.match(/filename="(.*?)"/);
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }

        // 4. 根据不同浏览器保存文件
        // IE/Edge 兼容
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
          this.$message.success('请选择保存路径');
          return;
        }

        // 现代浏览器（已提前获取文件句柄）
        if (hasFileHandle && fileHandle) {
          try {
            const writable = await fileHandle.createWritable();
            // 写入时会自动使用用户选择的路径，文件名以接口返回的为准
            await writable.write(blob);
            await writable.close();
            this.$message.success(`文件已保存到指定路径：${fileName}`);
            return;
          } catch (e) {
            console.log('保存文件失败', e);
          }
        }

        // 降级方案（老浏览器或现代浏览器失败时）
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 使用接口返回的真实文件名
        document.body.appendChild(a);
        a.click(); // 同步触发下载
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.$message.success(`文件已下载到默认目录：${fileName}`);

      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败，请重试');
      }
    }).catch(() => {
      this.$message.info('已取消导出');
    });
  }

  //  送检导出
  /** 导出按钮操作 */
  sjExport() {
    this.$confirm('是否确认导出送检数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => { // 用户点击了确定按钮
      const params = {
        beginTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[0] : undefined,
        endTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[1] : undefined,
      };

      sjExportInfor({ begin: params.beginTime, end: params.endTime })
        .then((response) => {
          const { data } = response;
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })); // 确保data是Blob类型，并设置正确的MIME类型
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = `送检数据.xls`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('导出失败:', error); // 处理导出失败的情况
        });
    }).catch(() => { // 用户点击了取消按钮
      // 这里可以处理取消操作，但通常不需要做什么，因为用户已经取消了导出
    });
  }

  healthCertificateExport() {
    this.$confirm('是否确认导出健康证数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => { // 用户点击了确定按钮
      const params = {
        beginTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[0] : undefined,
        endTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[1] : undefined,
      };

      healthCertExportInfor({ begin: params.beginTime, end: params.endTime })
        .then((response) => {
          const { data } = response;
          // 从响应头提取真实文件名（若无则用默认名）
          let fileName = '健康证.pdf';
          const contentDisposition = response.headers && response.headers['content-disposition'] || '';
          const match = contentDisposition.match(/filename="(.*?)"/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
          // 后端返回的是合并后的PDF流
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('导出失败:', error); // 处理导出失败的情况
        });
    }).catch(() => { // 用户点击了取消按钮
      // 这里可以处理取消操作，但通常不需要做什么，因为用户已经取消了导出
    });
  }



  handleExportAll() {
    this.$confirm('是否确认导出全部登记人员信息?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => { // 用户点击了确定按钮
      const params = {
        beginTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[0] : undefined,
        endTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[1] : undefined,
      };

      exportAllInfo({ begin: params.beginTime, end: params.endTime })
        .then((response) => {
          const { data } = response;
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })); // 确保data是Blob类型，并设置正确的MIME类型
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = `数据统计.xls`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('导出失败:', error); // 处理导出失败的情况
        });
    }).catch(() => { // 用户点击了取消按钮
      // 这里可以处理取消操作，但通常不需要做什么，因为用户已经取消了导出
    });
  }
}

